/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import {initAmplitude, trackPageView} from './src/utils/amplitude'

export const onClientEntry = () => {
  initAmplitude()
}

export const onRouteUpdate = ({location}) => {
  trackPageView(location.pathname, location.search)
}
